import { RootState } from "store/store";
import { TopicItem } from "./types.d";

export const manualTopicsSelector = (state: RootState) => {
  return state.manuals.topics;
};
export const manualTopicDetailSelector = (state: RootState) => {
  return state.manuals.topicDetail;
};
